import React from 'react';

import AlternateRoyaltyTable from './alternate_royalty_table';
import PropertyManagementTable from './property_management_table';
import ScheduleTable from './schedule_table';

export function RoyaltySettings() {
  return (
    <div className="d-flex flex-column gap-3">
      <ScheduleTable />
      <PropertyManagementTable />
      <AlternateRoyaltyTable />
    </div>
  );
}

export default RoyaltySettings;
